import React from 'react';
import { Checkbox as MUICheckbox } from '@mui/material';
import { cx } from '@emotion/css';
import { useStyles } from './Checkbox.styles';
export function Checkbox(props) {
    const classes = useStyles();
    const handleOnChange = (event, checked) => {
        if (props.onChange) {
            props.onChange(event, checked);
        }
    };
    return (React.createElement(MUICheckbox, { className: cx(props.className, classes.root), checked: props.checked, disabled: props.disabled, id: props.id, onChange: handleOnChange, color: props.color || undefined, indeterminate: props.indeterminate }));
}
//# sourceMappingURL=Checkbox.js.map